import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-faq',
    templateUrl: './block-faq.component.html',
})

export class BlockFAQComponent extends BlockAbstractComponent implements OnInit {

}
